import React from 'react';
import { Avatar, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import {
  OrganizationColorsSchema,
  SectionHeaderSchema,
} from '../../definitions/schemas';
import IconComponent from '../../icons';
import OrganizationThemeContextProvider from '../../lib/context/OrganizationThemeContext';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    height: theme.spacing(5),
    width: theme.spacing(5),
  },
  logo: {
    height: theme.spacing(6),
  },
  logoImg: {
    borderRadius: theme.spacing(0.5),
    objectFit: 'contain',
  },
}));

type ClassKey = 'icon' | 'logo';

interface Props {
  classes?: Partial<Record<ClassKey, string>>;
  orgColors?: OrganizationColorsSchema;
  sectionHeader: SectionHeaderSchema;
}

const SectionHeaderLogo: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { classes: classesProp, orgColors, sectionHeader } = props;

  const { icon, logoUrl, name, signedUrl } = sectionHeader;

  if (icon) {
    return (
      <OrganizationThemeContextProvider colors={orgColors}>
        <IconComponent
          className={classNames(classes.icon, classesProp?.icon)}
          iconColor
          name={`${icon}`}
        />
      </OrganizationThemeContextProvider>
    );
  }

  if (logoUrl || signedUrl) {
    return (
      <Avatar
        classes={{
          root: classNames(classes.logo, classesProp?.logo),
          img: classes.logoImg,
        }}
        src={logoUrl || signedUrl}
        variant="rounded"
      >
        {name[0].toUpperCase()}
      </Avatar>
    );
  }

  return <></>;
};

export default SectionHeaderLogo;
